import React from "react";
import styles from "../User/Auth.module.css";

// Dummy assets data
const assets = [
  {
    name: "Aurelia Logo (PNG)",
    url: "/assets/logos/aurelia-logo.png",
    type: "logo"
  },
  {
    name: "Aurelia Banner (JPG)",
    url: "/assets/banners/aurelia-banner.jpg",
    type: "banner"
  },
  {
    name: "Aurelia Apartments Social Media Square",
    url: "/assets/social/aurelia-social-square.png",
    type: "social"
  }
];

const AffiliateAssets = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.box}>
        <h2 className={styles.heading}>Affiliate Creative Assets</h2>
        <div className={styles.note}>
          Download and use these official Aurelia Apartments logos, banners, and images for your marketing campaigns.
        </div>
        <div style={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "24px", marginTop: "2rem"}}>
          {assets.map((asset, idx) => (
            <div key={idx} style={{border: "1px solid #eee", borderRadius: "8px", padding: "16px", background: "#fafcff", textAlign: "center"}}>
              <div style={{marginBottom: "12px"}}>
                <img src={asset.url} alt={asset.name} style={{maxWidth: "100%", maxHeight: "120px", objectFit: "contain"}} />
              </div>
              <div style={{fontWeight: "bold", marginBottom: "8px"}}>{asset.name}</div>
              <a href={asset.url} download style={{color: "#233d81", textDecoration: "underline", fontSize: "15px"}}>Download</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AffiliateAssets;
